module.exports = __webpack_public_path__ + "img/page智慧水利.1d0aa8a7.png";